// FollowButton.jsx
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import trackMixpanel, {
  EventTypes,
  getViewId,
  ButtonId,
} from '../resource/mixpanel.js';

import ResetButtonStyle from '../style/ResetButtonStyle';
import { color } from '../style/variables.js';

import AddIconSourceBlack from '../../img/ic_add_black.svg';
import CheckIconSource from '../../img/ic_complete_white_xs.svg';

export const FollowButton = ({
  meId,
  userId,
  isFollowing,
  isOnProfile,
  isBigSize,
  isOnSearch,
  t,
  sendFollowUser,
  sendUnfollowUser,
  fetchUserIsFollowing,
}) => {
  const [shouldShow, setShouldShow] = useState(
    isFollowing === false || !meId || isOnProfile || isOnSearch
  );
  useEffect(() => {
    if (meId && userId && isFollowing == null) {
      fetchUserIsFollowing({ userId });
    }
  }, [meId, userId, isFollowing, fetchUserIsFollowing]);
  useEffect(() => {
    if (isFollowing === false) {
      setShouldShow(true);
    }
  }, [isFollowing]);
  if (!shouldShow) {
    return null;
  }
  return (
    <StyledFollowButton
      isFollowing={isFollowing}
      isBigSize={isBigSize}
      onClick={() => {
        trackMixpanel({
          type: EventTypes.USER_CLICKED,
          payload: {
            viewId: getViewId({ pathname: window.location.pathname }),
            buttonId: isFollowing
              ? ButtonId.All.ButtonUnfollow
              : ButtonId.All.ButtonFollow,
          },
        });
        if (isFollowing) {
          return sendUnfollowUser({ userId });
        }
        return sendFollowUser({ userId });
      }}
    >
      <img src={isFollowing ? CheckIconSource : AddIconSourceBlack} />
      {t(isFollowing ? 'following' : 'follow')}
    </StyledFollowButton>
  );
};

FollowButton.propTypes = {
  meId: PropTypes.string,
  userId: PropTypes.string,
  isFollowing: PropTypes.bool,
  isOnProfile: PropTypes.bool,
  isBigSize: PropTypes.bool,
  isOnSearch: PropTypes.bool,
  t: PropTypes.func.isRequired,
  sendFollowUser: PropTypes.func,
  sendUnfollowUser: PropTypes.func,
  fetchUserIsFollowing: PropTypes.func,
};

FollowButton.defaultProps = {
  meId: null,
  userId: null,
  isFollowing: null,
  isOnProfile: false,
  isBigSize: false,
  isOnSearch: false,
  sendFollowUser: () => null,
  sendUnfollowUser: () => null,
  fetchUserIsFollowing: () => null,
};

const StyledFollowButton = styled.button.attrs(
  ({ isFollowing, isBigSize }) => ({
    style: {
      border: `1px solid ${isFollowing ? color.grey['700'] : color.sky}`,
      width: isBigSize ? '100%' : 'auto',
      height: `${isBigSize ? 36 : 24}px`,
      backgroundColor: isFollowing ? 'rgba(255, 255, 255, 0.1)' : color.sky,
      color: isFollowing ? 'rgba(255, 255, 255, 0.5)' : color.black,
      fontSize: `${isBigSize ? 16 : 12}px`,
      fontWeight: isBigSize ? 600 : 400,
    },
  })
)`
  ${ResetButtonStyle};
  border-radius: 4px;
  padding: 0px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    margin-right: 4px;
    width: ${({ isBigSize }) => (isBigSize ? 20 : 12)}px;
    height: ${({ isBigSize }) => (isBigSize ? 20 : 12)}px;
    opacity: ${({ isFollowing }) => (isFollowing ? 0.5 : 1)};
  }
`;

export default withTranslation()(FollowButton);
